import { createTheme } from "@mui/material"

const theme = createTheme({
  typography: {
    fontFamily: [
      "Inter",
      "sans-serif"
    ].join(","),
    h1: {
      fontSize: "42px",
      fontWeight: "bold",
      lineHeight: "64px"
    },
    h2: {
      fontSize: "36px",
      fontWeight: "bold",
      lineHeight: "54px",
    },
    h3: {
      fontSize: "24px",
      fontWeight: "bold",
      lineHeight: "48px",
    },
    h5: {
      fontSize: "18px",
      fontWeight: "bold",
      lineHeight: "22px",
    },
    h6: {
      fontSize: "24px",
      fontWeight: "semibold",
      lineHeight: "32px",
    },
    body1: {
      fontSize: "16px",
      lineHeight: "20px"
    },
    subtitle1: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "rgba(0, 0, 0, 0.3)"
    },
    subtitle2: {
      fontSize: "14px",
      lineHeight: "14px",
      fontWeight: 600,
      textTransform: "uppercase",
      color: "rgba(0, 0, 0, 0.5)"
    },
    caption: {
      fontSize: "11px",
      lineHeight: "11px",
      textTransform: "uppercase",
      color: "rgba(0, 0, 0, 0.5)"
    },
    button: {
    }
  },
  palette: {
    primary: {
      main: "#000099"
    },
    secondary: {
      main: "#F9F6F0",
      light: "#FFFFFF"
    },
    text: {
      primary: "#000",
      secondary: "#000"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "500px",
          padding: "6px 24px",
          fontWeight: "bold",
          fontSize: "14px"
        }
      }
    },
    MuiNativeSelect: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          borderRadius: "4px",
          padding: "8px",
          backgroundColor: "#F9F6F0",
        },
        select: {
          "&:focus": {
            background: "transparent"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "#00000015",
          borderRadius: "100px",
          height: "32px",
          minHeight: "32px",
          margin: "16px 0px",
        },
        indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          textTransform: "none",
          fontSize: "16px",
          height: "32px",
          minHeight: "32px",
          minWidth: "0px",
          "&.Mui-selected": {
            backgroundColor: "#000099",
            borderRadius: "100px",
            border: "none",
            color: "white",
            fontWeight: "bold",
          },
        },
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
              transform: "translateX(16px)",
              color: "#fff",
              "& + .MuiSwitch-track": {
                backgroundColor: "#65C466",
                opacity: 1,
                border: 0
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
              },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
              color: "#33cf4d",
              border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "grey"
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.7
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22,
          },
          "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: "#E9E9EA",
            opacity: 1,
            transition: "background-color 500ms"
          },
        }
      }
    },
  }
})

export default theme
